import DownloadWellStaticData from './containers/DownloadWellStaticDataContainer'

export default DownloadWellStaticData
